class ArticleCardBlock extends HTMLParagraphElement {
  constructor() {
    super();

    const template = document.getElementById("article-card-block");
    const templateContent = template.content;

    const shadowRoot = this.attachShadow({ mode: "open" }).appendChild(
      templateContent.cloneNode(true)
    );
  }
}

customElements.define("article-card-block", ArticleCardBlock);
